"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
import { Quote } from "lucide-react";
export default function WhoWeWorkWith() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const partners = [{
    type: "logo",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553131/img/partner_logo_luxury_hotels.png",
    alt: "Luxury Hotels Association",
    height: "h-16"
  }, {
    type: "text",
    content: "Milk + Honey sets the gold standard for luxury travel in Israel. Their attention to detail is unmatched.",
    author: "General Manager, The Jaffa"
  }, {
    type: "logo",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553131/img/partner_logo_private_aviation.png",
    alt: "Elite Private Aviation",
    height: "h-12"
  }, {
    type: "text",
    content: "We only trust our most discerning clients to this team. They deliver the impossible, every time.",
    author: "Head of Concierge, Amex Centurion"
  }, {
    type: "logo",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553131/img/partner_logo_culinary_experiences.png",
    alt: "Fine Dining Collective",
    height: "h-20"
  }, {
    type: "text",
    content: "A partnership built on a shared passion for excellence and authentic, unforgettable storytelling.",
    author: "Director, Six Senses Shaharut"
  }, {
    type: "logo",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553131/img/partner_logo_boutique_resorts.png",
    alt: "Boutique Resorts Israel",
    height: "h-14"
  }];
  const column1 = [partners[0], partners[3]];
  const column2 = [partners[1], partners[4], partners[6]];
  const column3 = [partners[2], partners[5]];
  return;
}
function PartnerCard({
  item,
  index
}: {
  item: {
    type: string;
    src?: string;
    alt?: string;
    content?: string;
    author?: string;
    height?: string;
  };
  index: number;
}) {
  return <div data-index={index} className="group">
      <Card className="border border-border/40 bg-card shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-400 ease-out h-full overflow-hidden">
        <CardContent className="p-8 flex flex-col items-center justify-center text-center h-full min-h-[200px]">
          {item.type === "logo" ? <div className="w-full h-full flex items-center justify-center p-4 grayscale group-hover:grayscale-0 transition-all duration-500 opacity-80 group-hover:opacity-100">
              {}
              <img src={item.src} alt={item.alt} className={cn("w-auto object-contain max-w-[180px]", item.height)} />
            </div> : <div className="flex flex-col items-center justify-center h-full">
              <Quote className="size-8 text-accent/40 mb-4 fill-accent/10" />
              <p className="text-primary font-sans text-lg font-medium leading-relaxed mb-4">
                &ldquo;{item.content}&rdquo;
              </p>
              <div className="w-8 h-[1px] bg-accent/50 mb-3" />
              <p className="text-muted-foreground text-sm font-sans uppercase tracking-widest">
                {item.author}
              </p>
            </div>}
        </CardContent>
      </Card>
    </div>;
}